import React from "react";
import cx from "clsx";
import { Transition } from "react-transition-group";

import globalStyles from "@/styles/global.module.scss";
import styles from "./dimmer.module.scss";

class Dimmer extends React.PureComponent {
  static defaultProps = {
    visible: true
  };

  state = {
    animating: false
  };

  componentDidMount() {
    if (!this.state.animating && this.props.visible)
      setTimeout(() => this.setState({ animating: true }), 1);
  }

  componentDidUpdate(prevProps) {
    const { visible, onClose } = this.props;

    if (!this.state.animating && this.props.visible)
      setTimeout(() => this.setState({ animating: true }), 1);
    else if (prevProps.visible && !visible) {
      this.setState({ animating: false });
      // Exiting
      if (onClose) setTimeout(onClose, 300);
    }
  }

  render() {
    const {
      children,
      noAnimation,
      customAnimation,
      className,
      style,
      onClick
    } = this.props;
    const { animating } = this.state;

    return (
      <Transition enter exit appear in={animating} timeout={0}>
        {state => {
          return (
            /* eslint-disable */
            <div
              role="article"
              onClick={onClick}
              className={cx(
                styles.dimmer,
                !noAnimation &&
                  !customAnimation &&
                  globalStyles.opacityAnimation,
                !noAnimation && !customAnimation && globalStyles[state],
                customAnimation && customAnimation(state),
                className
              )}
              style={style}
            >
              {children}
            </div>
            /* eslint-enable */
          );
        }}
      </Transition>
    );
  }
}

export default Dimmer;
